import { render, staticRenderFns } from "./RegistrarMovimientoDialogComponent.vue?vue&type=template&id=0b7c7b96&scoped=true"
import script from "./RegistrarMovimientoDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistrarMovimientoDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./RegistrarMovimientoDialogComponent.vue?vue&type=style&index=0&id=0b7c7b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c7b96",
  null
  
)

export default component.exports